// extracted by mini-css-extract-plugin
module.exports = {"InvitePeopleButton":"_2ewYE","invitePeopleButton":"_2ewYE"};